import { useAppStore } from '@/stores/app'
import { ECampaign } from '@/shared/enum/campaign.enum'
import { useChannels } from '@/shared/composables/useChannels'
import { useToken } from '@/shared/composables/useToken'

/**
 * Builds the URL to regenerate a token based on app and token state.
 */
export const buildRegenerateTokenUrl = (): string => {
  const appStore = useAppStore()
  const { campaign } = useToken()
  const { isMCAppChannel } = useChannels()

  if (isMCAppChannel.value) {
    return `https://${appStore.country}.claropayment.com/redirect/recarga`
  }

  if (campaign.value.toUpperCase() !== ECampaign.NULL) {
    return `https://${window.location.hostname}/cc/${campaign.value.toLowerCase()}`
  }

  return `https://${window.location.hostname}`
}

/**
 * Redirects the user to the regenerate token URL.
 */
export const redirectToRegenerateToken = (): void => {
  window.location.href = buildRegenerateTokenUrl()
}
